import { QUERY_KEYS } from '../../../../consts';
import { createSignEventService } from '../../../../services/sign/create-sign-event.service'
import { getAtomWithMutation } from '../../../../utils';

export const createSignEventAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.SIGNS.CREATE_SIGN_EVENT,
  mutationFn: () => createSignEventService,
});
